"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE_REGISTRY = exports.KILT_TYPES = void 0;
const type_definitions_1 = require("@kiltprotocol/type-definitions");
Object.defineProperty(exports, "KILT_TYPES", { enumerable: true, get: function () { return type_definitions_1.types8; } });
const types_1 = require("@polkadot/types");
const TYPE_REGISTRY = new types_1.TypeRegistry();
exports.TYPE_REGISTRY = TYPE_REGISTRY;
TYPE_REGISTRY.register(type_definitions_1.types8);
exports.default = TYPE_REGISTRY;
